var map = {
	"./Spin_TG-Centro_001.webp": 69754,
	"./Spin_TG-Centro_002.webp": 43043,
	"./Spin_TG-Centro_003.webp": 52831,
	"./Spin_TG-Centro_004.webp": 51735,
	"./Spin_TG-Centro_005.webp": 9925,
	"./Spin_TG-Centro_006.webp": 69860,
	"./Spin_TG-Centro_007.webp": 98016,
	"./Spin_TG-Centro_008.webp": 64541,
	"./Spin_TG-Centro_009.webp": 82894,
	"./Spin_TG-Centro_010.webp": 45863,
	"./Spin_TG-Centro_011.webp": 37621,
	"./Spin_TG-Centro_012.webp": 41507,
	"./Spin_TG-Centro_013.webp": 37678,
	"./Spin_TG-Centro_014.webp": 89019,
	"./Spin_TG-Centro_015.webp": 29069,
	"./Spin_TG-Centro_016.webp": 83616,
	"./Spin_TG-Centro_017.webp": 1119,
	"./Spin_TG-Centro_018.webp": 2234,
	"./Spin_TG-Centro_019.webp": 77123,
	"./Spin_TG-Centro_020.webp": 19398,
	"./Spin_TG-Centro_021.webp": 49075,
	"./Spin_TG-Centro_022.webp": 68738,
	"./Spin_TG-Centro_023.webp": 31953,
	"./Spin_TG-Centro_024.webp": 54929,
	"./Spin_TG-Centro_025.webp": 29226,
	"./Spin_TG-Centro_026.webp": 77938,
	"./Spin_TG-Centro_027.webp": 33194,
	"./Spin_TG-Centro_028.webp": 73334,
	"./Spin_TG-Centro_029.webp": 51137,
	"./Spin_TG-Centro_030.webp": 10661,
	"./Spin_TG-Centro_031.webp": 56365,
	"./Spin_TG-Centro_032.webp": 16168,
	"./Spin_TG-Centro_033.webp": 8981,
	"./Spin_TG-Centro_034.webp": 25428,
	"./Spin_TG-Centro_035.webp": 37023,
	"./Spin_TG-Centro_036.webp": 30039,
	"./Spin_TG-Centro_037.webp": 47534,
	"./Spin_TG-Centro_038.webp": 55016,
	"./Spin_TG-Centro_039.webp": 86224,
	"./Spin_TG-Centro_040.webp": 37627,
	"./Spin_TG-Centro_041.webp": 77779,
	"./Spin_TG-Centro_042.webp": 48465,
	"./Spin_TG-Centro_043.webp": 1911,
	"./Spin_TG-Centro_044.webp": 35837,
	"./Spin_TG-Centro_045.webp": 37365,
	"./Spin_TG-Centro_046.webp": 6215,
	"./Spin_TG-Centro_047.webp": 14013,
	"./Spin_TG-Centro_048.webp": 98837,
	"./Spin_TG-Centro_049.webp": 37478,
	"./Spin_TG-Centro_050.webp": 44233,
	"./Spin_TG-Centro_051.webp": 99498,
	"./Spin_TG-Centro_052.webp": 60241,
	"./Spin_TG-Centro_053.webp": 6797,
	"./Spin_TG-Centro_054.webp": 51356,
	"./Spin_TG-Centro_055.webp": 21107,
	"./Spin_TG-Centro_056.webp": 89126,
	"./Spin_TG-Centro_057.webp": 8305,
	"./Spin_TG-Centro_058.webp": 56867,
	"./Spin_TG-Centro_059.webp": 72597,
	"./Spin_TG-Centro_060.webp": 70307,
	"./Spin_TG-Centro_061.webp": 19490,
	"./Spin_TG-Centro_062.webp": 96409,
	"./Spin_TG-Centro_063.webp": 37665,
	"./Spin_TG-Centro_064.webp": 74916,
	"./Spin_TG-Centro_065.webp": 23689,
	"./Spin_TG-Centro_066.webp": 67026,
	"./Spin_TG-Centro_067.webp": 88018,
	"./Spin_TG-Centro_068.webp": 51261,
	"./Spin_TG-Centro_069.webp": 7077,
	"./Spin_TG-Centro_070.webp": 95761,
	"./Spin_TG-Centro_071.webp": 20864,
	"./Spin_TG-Centro_072.webp": 9176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77176;